import { TemplateRef } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ApiService } from "../../../services/api.service";
import { TemplateService } from "../../../services/template.service";
import { BsModalService } from 'ngx-bootstrap/modal';
var GroupedSaleTaxListDetailComponent = (function () {
    function GroupedSaleTaxListDetailComponent(apiService, modalService, template) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.template = template;
        this.config = {
            animated: true,
            class: 'tax-list-detail-modal'
        };
        this.totalSelected = [];
        this.checkedSelect = [];
        this.list = [];
        this.selectedValues = [];
        this.currentPage = 1;
        this.checked = false;
        this.title = "";
        this.loading = false;
    }
    GroupedSaleTaxListDetailComponent.prototype.open = function (selectedRowData) {
        var month = selectedRowData['month'];
        var year = selectedRowData['year'];
        this.searchParams['month'] = month;
        this.searchParams['year'] = year;
        this.title = "ภาษีขายประจำเดือน " + month + " ปี " + year;
        if (this.currentPage === 1)
            this.pageChanged();
        else
            this.currentPage = 1;
        this.modalRef = this.modalService.show(this.modalTemplate, this.config);
    };
    GroupedSaleTaxListDetailComponent.prototype.ngOnInit = function () {
    };
    GroupedSaleTaxListDetailComponent.prototype.pageChanged = function () {
        var params = new HttpParams().set('page', _.toString(this.currentPage));
        this.searchE(params);
    };
    GroupedSaleTaxListDetailComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    GroupedSaleTaxListDetailComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    GroupedSaleTaxListDetailComponent.prototype.searchE = function (params) {
        var _this = this;
        if (this.currentPage === 1) {
            this.apiService.postSearch(this.searchParams).subscribe(function (res) {
                _this.list = res.results;
                _this.totalItems = res.count;
            });
        }
        else {
            this.apiService.postSearch1(this.searchParams, params).subscribe(function (res) {
                _this.list = res.results;
                _this.totalItems = res.count;
            });
        }
    };
    GroupedSaleTaxListDetailComponent.prototype.Download = function () {
        var _this = this;
        var total = this.totalSelected.join(',');
        // const params = new HttpParams().set('list_id', total);
        // this.url = environment.apiURL + '/api/zip_xml/' + '?' + params;
        this.date = new Date();
        var params = new HttpParams().set('list_id', total);
        // this.url = environment.apiURL + '/api/zip_xml/' + '?' + params;
        this.loading = true;
        this.apiService.getZip(params).subscribe(function (obj) {
            var filename = 'documents' + moment().format('YYYY-MM-DD') + '.zip';
            _this.apiService.createDownloadFile(obj, filename);
            _this.pageChanged();
            _this.loading = false;
        }, function (error) {
            _this.loading = false;
        });
    };
    GroupedSaleTaxListDetailComponent.prototype.selectAll = function () {
        var _this = this;
        this.checkedSelect[this.currentPage] = !this.checkedSelect[this.currentPage];
        if (this.checkedSelect[this.currentPage]) {
            _.forEach(this.list, function (value) {
                _this.selectedValues[value.id] = true;
                _this.totalSelected.push(value.id);
            });
            this.totalSelected = _.uniq(this.totalSelected);
        }
        else {
            _.forEach(this.list, function (value) {
                _this.selectedValues[value.id] = false;
                _this.totalSelected = _.filter(_this.totalSelected, function (num) {
                    return num !== value.id;
                });
            });
        }
    };
    GroupedSaleTaxListDetailComponent.prototype.selectChild = function (id) {
        if (this.selectedValues[id]) {
            this.totalSelected.push(id);
        }
        else {
            this.totalSelected = _.filter(this.totalSelected, function (value) {
                return value !== id;
            });
        }
    };
    return GroupedSaleTaxListDetailComponent;
}());
export { GroupedSaleTaxListDetailComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/grouped-list-detail/grouped-list-detail.component.ts.pre-build-optimizer.js